export default __webpack_public_path__ + "static/media/Steelspirit Vambraces.00be3131.jpg";